/* unplugin-vue-components disabled */import { render } from "./AddressLayout.vue?vue&type=template&id=d398e2c8"
const script = {}

import "./AddressLayout.vue?vue&type=style&index=0&id=d398e2c8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__